import { render, staticRenderFns } from "./img-empty.vue?vue&type=template&id=041bff8e&scoped=true&"
import script from "./img-empty.vue?vue&type=script&lang=js&"
export * from "./img-empty.vue?vue&type=script&lang=js&"
import style0 from "./img-empty.vue?vue&type=style&index=0&id=041bff8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041bff8e",
  null
  
)

export default component.exports